import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { ExternalUrl } from '../../../../constants/url.mjs';
import '../../../../contexts/MenuContext/mapping.mjs';
import '../../../../hooks/index.mjs';
import { Avatar, NameWrap, Name, Email, CustomButton } from '../AccountFrame.styles.mjs';
import '../translations/index.mjs';
import { Wrap, CustomerWrap, ButtonGroup } from './Mobile.styles.mjs';
import { useTranslation } from '../../../../hooks/useTranslation.mjs';
import { Language } from '../../../../types/constants.mjs';
import EN_TRANSLATION from '../translations/en.json.mjs';
"use strict";
const AccountFrameMobile = function AccountFrameMobile2({
  renderImage,
  onClose,
  account
}) {
  const {
    formatMessage
  } = useTranslation({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () => import('../translations/ar.json.mjs').then(res => res.default),
      [Language.Ca]: () => import('../translations/ca.json.mjs').then(res => res.default),
      [Language.Cs]: () => import('../translations/cs.json.mjs').then(res => res.default),
      [Language.Da]: () => import('../translations/da.json.mjs').then(res => res.default),
      [Language.Nl]: () => import('../translations/nl.json.mjs').then(res => res.default),
      [Language.Fr]: () => import('../translations/fr.json.mjs').then(res => res.default),
      [Language.De]: () => import('../translations/de.json.mjs').then(res => res.default),
      [Language.El]: () => import('../translations/el.json.mjs').then(res => res.default),
      [Language.It]: () => import('../translations/it.json.mjs').then(res => res.default),
      [Language.Ja]: () => import('../translations/ja.json.mjs').then(res => res.default),
      [Language.Ko]: () => import('../translations/ko.json.mjs').then(res => res.default),
      [Language.No]: () => import('../translations/no.json.mjs').then(res => res.default),
      [Language.Pl]: () => import('../translations/pl.json.mjs').then(res => res.default),
      [Language.PtPt]: () => import('../translations/pt-PT.json.mjs').then(res => res.default),
      [Language.EsMx]: () => import('../translations/es-MX.json.mjs').then(res => res.default),
      [Language.Sv]: () => import('../translations/sv.json.mjs').then(res => res.default),
      [Language.Tr]: () => import('../translations/tr.json.mjs').then(res => res.default),
      [Language.Zh]: () => import('../translations/zh-Hans.json.mjs').then(res => res.default),
      [Language.Tw]: () => import('../translations/zh-Hant-TW.json.mjs').then(res => res.default),
      [Language.PtBr]: () => import('../translations/pt-BR.json.mjs').then(res => res.default),
      [Language.Ru]: () => import('../translations/ru.json.mjs').then(res => res.default),
      [Language.EsEs]: () => import('../translations/es-ES.json.mjs').then(res => res.default)
    }
  });
  const hasAccountEvents = useMemo(() => {
    return !!(account?.handleLogin && account.handleRegister && account.handleLogout);
  }, [account]);
  const handleUnifiSiteManager = useCallback(() => {
    window.open(ExternalUrl.UNIFI_SITE_MANAGER);
    onClose();
  }, [onClose]);
  const onCloseFn = useCallback(fn => {
    return () => {
      fn?.();
      onClose();
    };
  }, [onClose]);
  return /* @__PURE__ */jsxs(Wrap, {
    children: [account?.customer && /* @__PURE__ */jsxs(CustomerWrap, {
      children: [/* @__PURE__ */jsx(Avatar, {
        renderImage,
        src: account?.customer.picture,
        size: "medium"
      }), /* @__PURE__ */jsx(NameWrap, {
        children: /* @__PURE__ */jsx(Name, {
          children: account?.customer.displayName
        })
      }), /* @__PURE__ */jsx(Email, {
        children: account?.customer.email
      })]
    }), account?.customer && account.handleOrderHistory && /* @__PURE__ */jsx(CustomButton, {
      full: true,
      variant: "primary",
      onClick: onCloseFn(account?.handleOrderHistory),
      children: formatMessage("Order History")
    }), !account?.customer && account?.handleLogin && /* @__PURE__ */jsx(CustomButton, {
      full: true,
      variant: "primary",
      onClick: onCloseFn(account?.handleLogin),
      children: formatMessage("Log In")
    }), (!hasAccountEvents || account?.customer && !account?.handleManageAccount) && /* @__PURE__ */jsx(CustomButton, {
      full: true,
      variant: "primary",
      href: ExternalUrl.ACCOUNT,
      anchor: true,
      children: formatMessage("UI Account")
    }), /* @__PURE__ */jsxs(ButtonGroup, {
      children: [!account?.customer && account?.handleRegister && /* @__PURE__ */jsx(CustomButton, {
        full: true,
        variant: "gray",
        onClick: onCloseFn(account?.handleRegister),
        children: formatMessage("Sign Up")
      }), /* @__PURE__ */jsx(CustomButton, {
        full: true,
        variant: "gray",
        onClick: handleUnifiSiteManager,
        children: formatMessage("UniFi Site Manager")
      }), account?.customer && /* @__PURE__ */jsxs(Fragment, {
        children: [account?.handleManageAccount && /* @__PURE__ */jsx(CustomButton, {
          full: true,
          variant: "gray",
          onClick: onCloseFn(account?.handleManageAccount),
          children: formatMessage("Manage Account")
        }), /* @__PURE__ */jsx(CustomButton, {
          full: true,
          variant: "gray",
          onClick: onCloseFn(account?.handleLogout),
          children: formatMessage("Sign Out")
        })]
      })]
    })]
  });
};
export { AccountFrameMobile };
//# sourceMappingURL=Mobile.mjs.map
